/**
* Logger.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* JSLL Logger.
*/
import dynamicProto from "@microsoft/dynamicproto-js";
import { _warnToConsole } from "@microsoft/1ds-core-js";
var Logger = /** @class */ (function () {
    function Logger(sku) {
        var _logger = sku.logger;
        function _logWarning(message) {
            // console.warn will be used always if available, console.log is fallback
            _warnToConsole(_logger, message);
        }
        dynamicProto(Logger, this, function (_self) {
            _self.logError = _logWarning;
            _self.logWarning = _logWarning;
            _self.logInformation = _logWarning;
        });
    }
    Logger.prototype.logError = function (message) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    Logger.prototype.logWarning = function (message) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    Logger.prototype.logInformation = function (message) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    return Logger;
}());
export { Logger };
//# sourceMappingURL=Logger.js.map